import React, { createContext, useContext, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    getAllObservations,
    clearObservations
} from 'app/redux/slices/observationSlice';
import {
    getAllARImages,
    clearARImages,
} from 'app/redux/slices/arImageSlice';
import {
    getAllARVideos,
    clearARVideos,
} from 'app/redux/slices/arVideoSlice';
import {
    getAllLocations,
    clearLocations,
} from 'app/redux/slices/locationSlice';

const ObservationContext = createContext(null);

export const ObservationProvider = ({ projectId, children }) => {
    const dispatch = useDispatch();
    const observationsRaw = useSelector(state => state.observations);
    const locationsRaw = useSelector(state => state.locations);
    const arImagesRaw = useSelector(state => state.arImages);
    const arVideosRaw = useSelector(state => state.arVideos);

    const observations = useMemo(() => observationsRaw || {}, [observationsRaw]);
    const locations = useMemo(() => locationsRaw || {}, [locationsRaw]);
    const arImages = useMemo(() => arImagesRaw || {}, [arImagesRaw]);
    const arVideos = useMemo(() => arVideosRaw || {}, [arVideosRaw]);

    useEffect(() => {
        if (projectId) {
            dispatch(getAllObservations({ projectId }));
            dispatch(getAllLocations({ projectId }));
            dispatch(getAllARImages({ projectId }));
            dispatch(getAllARVideos({ projectId }));
        }

        return () => {
            dispatch(clearObservations());
            dispatch(clearLocations());
            dispatch(clearARImages());
            dispatch(clearARVideos());
        };
    }, [dispatch, projectId]);

    const value = useMemo(() => ({
        observations,
        locations,
        arImages,
        arVideos,
    }), [observations, locations, arImages, arVideos]);

    return (
        <ObservationContext.Provider value={value}>
            {children}
        </ObservationContext.Provider>
    );
};

export const useObservation = () => useContext(ObservationContext);
